<template>
  <div id="app-center">
    <my-head></my-head>
    <!-- <center-head></center-head> -->
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left" style="padding-top: 20px;">
              <el-form ref="form" :model="form" :rules="ruleValidate" label-width="155px">
                <p style="margin:0 20px 20px 20px; font-size:28px">公益项目申请拨款资料</p>
                <p class="register_head" v-show="active==0">
                  基础资料：
                  <span class="login"></span>
                  <span style="float:right">
                    项目预算：
                    <span style="color:red">{{extraInfo.total_funds}}</span>
                    <span style="color: #606266;font-size: 14px;">（人民币： {{total_funds_text}} ）</span>
                    捐款余额：
                    <span style="color:red">{{extraInfo.money_balance}}</span>元
                  </span>
                </p>
                <table class="table" v-show="active==0">
                  <tr>
                    <td>
                      <el-form-item label="申请人：" :disabled="isAbled" prop="apply_user_name">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.apply_user_name"
                          :maxlength="64"
                          placeholder="请输入申请人"
                        ></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="本次拨款方式：">
                        <el-input
                          style="width: 80%"
                          size="small"
                          readonly
                          value="转账"
                          :maxlength="64"
                          placeholder="请输入本次拨款方式(转账)"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item label="收款类型">
                        <el-radio-group v-model="form.payee_type" size="small">
                          <el-radio :label="1" border>单个</el-radio>
                          <el-radio :label="2" border>多个</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </td>

                    <td v-if="form.payee_type == 1">
                      <el-form-item label="收款单位名称：" prop="payee_unit_name">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.payee_unit_name"
                          :maxlength="64"
                          placeholder="请输入收款单位名称"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr v-if="form.payee_type == 1">
                    <td>
                      <el-form-item label="收款单位联系人：" prop="payee_rela_user_name">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.payee_rela_user_name"
                          :maxlength="64"
                          placeholder="请输入收款单位项目联系人"
                        ></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="收款单位联系方式：" prop="payee_office_phone" required>
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.payee_office_phone"
                          placeholder="请输入办公座机(023) 4561 XXXX"
                        ></el-input>
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.payee_telephone"
                          placeholder="请输入手机(135 XXXX XXXX)"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr v-if="form.payee_type == 1">
                    <td>
                      <el-form-item label="收款单位开户行：" prop="bank_name">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.bank_name"
                          :maxlength="64"
                          placeholder="请输入收款单位开户行(例如:建设银行)"
                        ></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="收款单位账号：" prop="account_number">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.account_number"
                          :maxlength="64"
                          placeholder="请输入收款单位账号"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr v-if="form.payee_type == 1">
                    <td>
                      <el-form-item label="收款单位开户名称：" prop="account_name">
                        <el-input
                          style="width: 80%"
                          size="small"
                          v-model="form.account_name"
                          :maxlength="64"
                          placeholder="请输入收款单位开户名称"
                        ></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="本次拨款金额：" prop="apply_money">
                        <el-input-number
                          style="width: 80%"
                          v-model="form.apply_money"
                          @blur="changeDx"
                          size="small"
                          :min="0.00"
                          :controls="false"
                          :precision="2"
                          placeholder="0.00"
                          type="number"
                        ></el-input-number>
                        <p>
                          <span v-show="form.apply_money!=''">{{apply_money_text}}元</span>
                        </p>
                      </el-form-item>
                    </td>
                  </tr>

                  <tr v-if="form.payee_type == 2">
                    <el-form-item label="拨款信息Excel" required>
                      <el-upload
                        class="upload-demo"
                        :action="uploadFileUrl"
                        :on-success="onSuccess3"
                        :before-upload="beforeUploadFile"
                        :limit="1"
                        :file-list="payExcel"
                        :on-remove="handleRemove3"
                      >
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                    </el-form-item>
                  </tr>

                  <tr v-if="form.payee_type == 2">
                    <el-form-item label="盖章扫描件集合" required>
                      <el-upload
                        ref="imgUploads"
                        :action="uploadImgUrl"
                        list-type="picture-card"
                        :on-preview="handleStampPreview"
                        :on-success="onSuccessPayPic"
                        :file-list="stamp_pics"
                        :data="{file_type:2}"
                        name="img"
                        multiple
                        :on-remove="handleRemovePayPic"
                        :before-upload="beforeAvatarUpload"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </tr>
                  <tr v-if="form.payee_type == 2">
                    <td>
                      <el-form-item label="本次拨款总额：" prop="apply_money">
                        <el-input-number
                          style="width: 80%"
                          v-model="form.apply_money"
                          @blur="changeDx"
                          size="small"
                          :min="0.00"
                          :controls="false"
                          :precision="2"
                          placeholder="0.00"
                          type="number"
                        ></el-input-number>
                        <p>
                          <span v-show="form.apply_money!=''">{{apply_money_text}}元</span>
                        </p>
                      </el-form-item>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <el-form-item label="本拨款事由：" prop="payment_reason">
                        <el-input
                          style="width: 92%"
                          type="textarea"
                          v-model="form.payment_reason"
                          rows="4"
                          size="small"
                          :maxlength="200"
                          placeholder="请输入拨款事由,最大输入200个文字"
                        ></el-input>
                      </el-form-item>
                    </td>
                  </tr>

                  <tr class="nomaltr" v-show="funds.length>0">
                    <td colspan="2" style="width: 100% !important">
                      <el-form-item label="以往资金拨款情况：" style="margin-bottom: 50px">
                        <div class="post_main_p" style="width:98%">
                          <div class="post-period-more-list">
                            <div class="post-period-main post-period-main-single">
                              <ul class="post-period-ul">
                                <li class="post-period-li">
                                  <div class="post-period-itembar thisover">
                                    <div class="post-period-item-top">
                                      <span class="item-top-limit" style="width: 12%">拨款批次</span>
                                      <span class="item-top-limit" style="width: 12%">金额</span>
                                      <span class="item-top-limit" style="width: 15%">结回资金类型</span>
                                      <span class="item-top-limit" style="width: 16%">结回资金</span>
                                      <span class="item-top-limit" style="width: 14%">实施例数</span>
                                      <span class="item-top-limit" style="width: 15%">结回资金凭证</span>
                                      <span class="item-top-set" style="width: calc(12% - 2px)">日期</span>
                                      <!-- <span class="item-top-set" style="width: calc(12% - 10px)">备注</span> -->
                                    </div>
                                    <div class="post-item-drag-area">
                                      <section
                                        v-for="(element,index) in funds"
                                        v-bind:key="index"
                                        class="post-period-item-group"
                                      >
                                        <div class="item-drag-top">
                                          <div
                                            class="item-group-k-limit"
                                            style="width: 10%; margin-left: 0.5%; margin-right: 0.5%;"
                                          >
                                            <span
                                              class="item-group-k-limit-input"
                                              style="color: #65717f;"
                                            >第{{index+1}}批次</span>
                                          </div>

                                          <div
                                            class="item-group-k-limit"
                                            style="width: 11%; margin-left: 1%; margin-right: calc(1% + 0px);"
                                          >
                                            <span>{{funds[index].apply_money}}</span>
                                            <!-- <el-input 
                                                    readonly    
                                                    :value="funds[index].apply_money"  
                                                    size="small"  
                                                    class="item-group-k-limit-input">
                                            </el-input>-->
                                          </div>

                                          <div
                                            class="item-group-k-limit"
                                            style="width: 14%; margin-left: 0%; margin-right: calc(1% + 0px);"
                                          >
                                            <el-select
                                              v-model="funds[index].return_funds_type"
                                              size="small"
                                              placeholder="选择类型"
                                            >
                                              <el-option
                                                v-for="item in returnFundsType"
                                                :key="item.value"
                                                :label="item.text"
                                                :value="item.value"
                                              ></el-option>
                                            </el-select>
                                          </div>

                                          <div
                                            class="item-group-k-limit"
                                            style="width: 16%; margin-left: 0%; margin-right: calc(1% + 0px);"
                                          >
                                            <el-input-number
                                              style="width:95%"
                                              :min="0"
                                              :precision="2"
                                              :controls="false"
                                              v-model="funds[index].return_funds"
                                              size="small"
                                              class="item-group-k-limit-input"
                                            ></el-input-number>
                                          </div>
                                          <div
                                            class="item-group-k-limit"
                                            style="width: 12%; margin-left: 0%; margin-right: calc(1% + 0px);"
                                          >
                                            <el-input-number
                                              style="width:95%"
                                              :min="0"
                                              :precision="0"
                                              :controls="false"
                                              v-model="funds[index].disease"
                                              size="small"
                                              class="item-group-k-limit-input"
                                            ></el-input-number>
                                          </div>
                                          <el-input
                                            v-show="false"
                                            :value="funds[index].id"
                                            size="small"
                                            class="item-group-k-limit-input"
                                          ></el-input>
                                          <div
                                            class="item-group-k-limit"
                                            style="width: 12%; margin-left: 1%; margin-right: calc(1% + 0px);"
                                          >
                                            <el-popover
                                              placement="right"
                                              width="400"
                                              trigger="click"
                                            >
                                              <el-upload
                                                class="upload-demo"
                                                :action="uploadImgUrl"
                                                name="img"
                                                :data="{'item_name':index,'file_type':2}"
                                                :on-preview="fundshandlePreview"
                                                :on-remove="fundshandleRemove"
                                                :on-success="handleAvatarSuccess"
                                                :file-list="imageUrl[index]"
                                                list-type="picture"
                                              >
                                                <el-button size="small" type="primary">点击上传</el-button>
                                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                                              </el-upload>
                                              <el-button size="small" slot="reference">上传凭证</el-button>
                                            </el-popover>
                                          </div>
                                          <div
                                            class="item-group-k-limit"
                                            style="width: 12%; margin-left: 2%; margin-right: calc(1% + 1px);"
                                          >
                                            <el-input
                                              readonly
                                              :value="funds[index].reg_time"
                                              size="small"
                                              class="item-group-k-limit-input"
                                            ></el-input>
                                          </div>
                                        </div>
                                        <div class="post-item-drag-area" style="margin-left:-11%">
                                          <el-form-item label="备注：">
                                            <el-input
                                              style="width:95%;margin-left:3%"
                                              v-model="funds[index].return_remark"
                                              placeholder="最大输入225个文字"
                                              :maxlength="225"
                                              type="textarea"
                                              rows="4"
                                              class="item-group-k-limit-input"
                                            ></el-input>
                                          </el-form-item>
                                        </div>
                                      </section>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </el-form-item>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <el-form-item label="实施地区" prop="province_id">
                        <el-select
                          v-model="form.province_id"
                          placeholder="请选择省份"
                          @change="getCity"
                          :popper-append-to-body="false"
                        >
                          <el-option
                            v-for="item in provinceLists"
                            :key="item.id"
                            :label="item.fullname"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-model="form.city_id"
                          placeholder="请选择城市"
                          @change="getCounty"
                          :clearable="true"
                          :popper-append-to-body="false"
                        >
                          <el-option
                            v-for="item in cityLists"
                            :key="item.id"
                            :label="item.fullname"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-model="form.county_id"
                          placeholder="请选择县/区"
                          :clearable="true"
                          :popper-append-to-body="false"
                        >
                          <el-option
                            v-for="item in countyLists"
                            :key="item.id"
                            :label="item.fullname"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>

                  <template v-if="extraInfo.apply_pay_count > 0">
                    <tr>
                      <td colspan="2">
                        <el-form-item label="项目进展附件上传：" prop="progress_file_id">
                          <el-upload
                            class="upload-demo"
                            :action="uploadFileUrl"
                            :on-success="onSuccess"
                            :limit="1"
                            :on-remove="handleRemove"
                            :file-list="form.fileList"
                          >
                            <el-button size="small" type="primary">点击上传</el-button>
                          </el-upload>
                        </el-form-item>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <el-form-item label="筛查名单excel：" prop="report_screen_list_file_id">
                          <el-upload
                            class="upload-demo"
                            :action="uploadFileUrl"
                            :before-upload="beforeUploadFile"
                            :on-success="onSuccess1"
                            :limit="1"
                            :on-remove="handleRemove1"
                            :file-list="form.fileList1"
                          >
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div class="el-upload__tip" slot="tip">只能上传xls、xlsx文件</div>
                          </el-upload>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <el-form-item label="筛查名单盖章图集：" prop="report_stamp_pic">
                          <el-upload
                            :action="uploadImgUrl"
                            name="img"
                            list-type="picture-card"
                            :before-upload="beforeAvatarUpload"
                            :on-success="onSuccessStampPic"
                            :on-preview="handleStampPreview"
                            :file-list="form.report_stamp_pics"
                            :data="{file_type:2}"
                            :on-remove="handleRemoveStampPic"
                          >
                            <i class="el-icon-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <el-form-item label="筛查名单人数：">
                          <el-input
                            style="width: 80%"
                            size="small"
                            v-model="form.report_screen_number"
                            placeholder="请输入筛查人数"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </template>

                  <tr>
                    <td colspan="2">
                      <el-button
                        type="primary"
                        :disabled="isAbled"
                        style="margin-top: 20px; float:right; margin-bottom: 20px;"
                        size="small"
                        @click="submit"
                      >
                        提交
                        <i class="el-icon-arrow-right el-icon--right"></i>
                      </el-button>
                    </td>
                  </tr>
                </table>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import "../public/poster.less";
import Axios from "axios";
import myHead from "../public/head";
import centerHead from "../public/center_head";
import leftMenu from "../public/menu";
import footDiv from "../public/foot";
import baseUrl from "@/config/index";
import ueditor from "@/components/ueditor.vue";
// import { quillEditor } from 'vue-quill-editor' //调用编辑器
import excel from "@/libs/excel";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    ueditor
  },
  data() {
    var checkAddress = (rule, value, callback) => {
      if (this.form.province_id && this.form.city_id) {
        return callback();
      } else {
        return callback(new Error("请完善实施地区！"));
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (this.form.payee_telephone) {
        let mobile = /^[1][0-9]{10}$/;
        if (!mobile.test(this.form.payee_telephone)) {
          return callback(new Error("手机号码格式不正确！"));
        } else {
          return callback();
        }
      } else if (this.form.payee_office_phone) {
        return callback();
      }
      return callback(new Error("收款单位联系方式必须填写一个！"));
    };
    return {
      extraInfo: {}, //获取相关金额数据
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 300,
        scaleEnabled: true
      },
      provinceLists: [], //省集合
      cityLists: [], //市集合
      countyLists: [], //县集合
      stamp_pics: [], //多个账号拨款盖章图片
      payExcel: [], //
      defPics: [], //
      stamp_pic: [], //扫描文件
      dialogImageUrl: "",
      dialogVisible: false,
      isAbled: false, //是否可以编辑
      returnFundsType: [],
      imageUrl: [],
      editorOption: {},
      apply_money_text: "",
      total_funds: "",
      total_funds_text: "",
      funds: [],
      active: 0,
      form: {
        stamp_pics: [],
        payee_type: 1,
        id: "", //项目Id
        apply_pay_id: "", //申请捐款id
        apply_user_name: "",
        payee_unit_name: "",
        payee_rela_user_name: "",
        payee_office_phone: null,
        payee_telephone: null,
        bank_name: "",
        account_name: "",
        account_number: "",
        payment_reason: "",
        apply_money: "",
        province_id: null,
        city_id: null,
        county_id: null,
        funds: [],

        progress_file_id: "", //项目附件
        report_stamp_pic: [], //筛查名单盖章图集
        report_screen_number: null, //筛查名单人数
        fileList: []
      },
      uploadLoading: false,
      progressPercent: 0,
      showProgress: false,
      showRemoveFile: false,
      file: null,
      tableData: [],
      tableTitle: [],
      tableLoading: false,
      ruleValidate: {
        apply_user_name: [
          { required: true, message: "请输入申请人", trigger: "blur" }
        ],
        payee_unit_name: [
          { required: true, message: "请输入收款单位名称", trigger: "blur" }
        ],
        apply_money: [
          { required: true, message: "请输入本次拨款金额", trigger: "blur" }
        ],
        payee_rela_user_name: [
          {
            required: true,
            message: "请输入收款单位项目联系人",
            trigger: "blur"
          }
        ],
        bank_name: [
          { required: true, message: "请输入收款单位开户行", trigger: "blur" }
        ],
        account_name: [
          { required: true, message: "请输入收款单位开户名称", trigger: "blur" }
        ],
        account_number: [
          { required: true, message: "请输入收款单位账号", trigger: "blur" }
        ],
        payment_reason: [
          { required: true, message: "请输入拨款事由", trigger: "blur" }
        ],
        progress_file_id: [
          { required: true, message: "请输入项目进展附件", trigger: "blur" }
        ],
        payee_office_phone: [{ validator: checkPhone, trigger: "blur" }],
        province_id: [{ validator: checkAddress, trigger: "change" }]
      },
      stepRules: [
        [
          "apply_user_name",
          "payee_unit_name",
          "payee_rela_user_name",
          "bank_name",
          "account_name",
          "account_number",
          "payment_reason",
          "apply_money",
          "progress_file_id"
        ]
      ]
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },

  created() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.getExtendInfo(this.$route.query.id, this.$route.query.apply_pay_id);
    this.form.id = this.$route.query.id;
    this.form.apply_pay_id = this.$route.query.apply_pay_id;

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceLists = resp.data;
      }
    });

    if (this.form.id) {
      this.$db
        .post(this.$db.config.publicPaymentHistory, { id: this.form.id })
        .then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.funds = res.data;
              this.funds.forEach((item, index) => {
                if (item.fund_pics) {
                  this.$set(this.imageUrl, index, item.fund_pics);
                }
                !this.funds[index]["return_funds_type"] &&
                  (this.funds[index]["return_funds_type"] = 1);
              });
            }
          }
        });
    }

    //详情接口
    if (this.form.apply_pay_id > 0) {
      this.$db
        .post(this.$db.config.publicPaymentDetails, {
          apply_pay_id: this.form.apply_pay_id,
          id: this.form.id
        })
        .then(res => {
          if (res.code == 200 && res.data) {
            this.form = res.data;
            this.form.id = this.$route.query.id;
            if (this.form.apply_money) {
              this.apply_money_text = this.DX(this.form.apply_money);
            }
            if (this.form.progress_file_id && this.form.file_source_name) {
              let fileArr = {
                name: this.form.file_source_name,
                id: this.form.progress_file_id
              };
              this.$set(this.form, "fileList", []);
              this.form.fileList.push(fileArr);
            }
            if (this.form.report_stamp_pics) {
              this.form.report_stamp_pics.forEach((item, index) => {
                this.form.report_stamp_pics[index]["url"] = item.pic_path;
              });
            }
            if (res.data.pay_file_path) {
              this.payExcel = [
                { name: res.data.pay_file_name, url: res.data.pay_file_path }
              ];
            }

            if (res.data.stamp_pics && res.data.stamp_pics.length > 0) {
              this.defPics = res.data.stamp_pics;
              this.stamp_pics = res.data.stamp_pics;
            }

            // 省市县
            if (res.data.province_id) {
              this.form.province_id = res.data.province_id;
              this.getCity(this.form.province_id, true);
            }

            if (res.data.city_id) {
              this.form.city_id = res.data.city_id;
              this.getCounty(this.form.city_id, true);
            }

            if (res.data.county_id) {
              this.form.county_id = res.data.county_id;
            }
          }
        });
    }

    //费用单位
    this.$db
      .post(this.$db.config.getDictParam, { pid: 200401, table: "pub_dict" })
      .then(res => {
        if (res.code == 200) {
          this.returnFundsType = res.data;
        }
      });
  },
  methods: {
    // 返回申请捐款列表页面

    //获取额外的信息
    getExtendInfo(pid, aid) {
      this.$db
        .post(this.$db.config.getComProPayOutExtendInfo, {
          id: pid,
          apply_pay_id: aid
        })
        .then(res => {
          if (res.code == 200) {
            this.extraInfo = res.data;
            res.data.total_funds &&
              (this.total_funds_text = this.DX(parseInt(res.data.total_funds)));
          }
        });
    },

    //获取市
    getCity(value, isEdit = false) {
      if (!isEdit) {
        this.form.city_id = null;
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityLists = resp.data;
          }
        });
    },
    //获取县区
    getCounty(value, isEdit = false) {
      if (!isEdit) {
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyLists = resp.data;
          }
        });
    },

    goBack() {
      this.$router.push({
        name: "hospitalProjectPaymentList",
        query: {
          id: this.form.id,
          apply_pay_id: this.form.apply_pay_id,
          apply_pay_count: this.extraInfo.apply_pay_count
        }
      });
    },
    fundshandleRemove(file, fileList) {
      let item_name = "";
      let item_id = "";
      if (file.item_name || file.item_name == 0) {
        item_name = Number(file.item_name);
        item_id = Number(file.pic_id);
      } else {
        item_name = Number(file.response.data.item_name);
        item_id = Number(file.response.data.id);
      }
      this.funds[item_name]["return_funds_pic"].forEach((item, index) => {
        if (Number(item) == item_id) {
          this.funds[item_name]["return_funds_pic"].splice(index, 1);
        }
      });
    },
    fundshandlePreview(file) {
      console.log(file);
    },
    handleAvatarSuccess(res, file) {
      res.data.item_name = Number(res.data.item_name);
      if (!this.funds[res.data.item_name]["return_funds_pic"]) {
        this.$set(this.funds[res.data.item_name]["return_funds_pic"], "", []);
      }
      this.funds[res.data.item_name]["return_funds_pic"].push(res.data.id);
    },
    beforeAvatarUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //多个拨款扫描图集 上传成功
    onSuccessPayPic(response, file, fileList) {
      this.stamp_pics = fileList;
    },
    //多个拨款扫描图集 删除
    handleRemovePayPic(file, fileList) {
      this.stamp_pics = fileList;
    },

    //扫描图集 上传成功
    onSuccessStampPic(response, file, fileList) {
      this.stamp_pic.push(file.data.id);
    },
    //扫描图集 删除
    handleRemoveStampPic(file, fileList) {
      let imgArr = [];
      fileList.forEach((item, index) => {
        imgArr.push(item.response.data.id);
      });
      this.stamp_pic = imgArr;
    },
    //扫描图集预览
    handleStampPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submit() {
      let _this = this;
      _this.flag = true;
      this.form.report_stamp_pic = this.stamp_pic;
      let pics = [];
      this.stamp_pics.forEach(item => {
        if (item.hasOwnProperty("response")) {
          pics.push(item.response.data.id);
        } else {
          pics.push(item.id);
        }
      });
      this.form.stamp_pics = pics;
      if (typeof this.stepRules[this.active] !== "undefined") {
        if (this.form.payee_type == 1) {
          if (this.stepRules[this.active].length > 0) {
            this.stepRules[this.active].forEach((item, index) => {
              this.$refs["form"].validateField(item, function(valid) {
                if (valid) {
                  _this.flag = false;
                }
              });
            });
          }
        } else {
          let arr = ["apply_user_name", "payment_reason", "apply_money"];
          if (!this.form.pay_file) {
            return this.$message.error("拨款信息Excel必须上传");
          }
          if (this.form.stamp_pics.length <= 0) {
            return this.$message.error("盖章扫描件集合必须上传");
          }
          arr.forEach((item, index) => {
            this.$refs["form"].validateField(item, function(valid) {
              if (valid) {
                _this.flag = false;
              }
            });
          });
        }
      }
      if (_this.flag) {
        let url = "";
        if (this.form.apply_pay_id) {
          url = this.$db.config.publicPaymentApplyEdit;
        } else {
          url = this.$db.config.publicPaymentApply;
        }
        this.form.funds = this.funds;

        this.$db.post(url, this.form).then(res => {
          if (res.code == 200) {
            this.$message.success("提交成功");
            let that = this;
            setTimeout(function() {
              that.$router.push({ name: "hospitalComProjectList" });
            }, 1000);
          }
        });
      } else {
        this.$message.warning("请填写完整的信息！");
      }
    },

    onEditorReady(editor) {},
    handleRemove(file, fileList) {
      this.form.progress_file_id = "";
    },
    onSuccess(response, file, fileList) {
      this.$set(this.form, "progress_file_id", response.data.id);
    },
    handleRemove1(file, fileList) {
      this.form.report_screen_list_file_id = "";
    },
    onSuccess1(response, file, fileList) {
      this.$set(this.form, "report_screen_list_file_id", response.data.id);
    },

    handleRemove3(file, fileList) {
      this.form.pay_file = "";
    },
    onSuccess3(response, file, fileList) {
      this.$set(this.form, "pay_file", response.data.id);
    },
    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file, ["xls", "xlsx"]);
      return bool;
    },

    changeDx() {
      if (this.form.apply_money) {
        this.apply_money_text = this.DX(this.form.apply_money);
      }
    },

    //金额转成大写
    DX(n) {
      if (Number(n) > 0) {
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
          str = "";
        n += "00";
        var p = n.indexOf(".");
        if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
          str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
        return str
          .replace(/零(仟|佰|拾|角)/g, "零")
          .replace(/(零)+/g, "零")
          .replace(/零(万|亿|元)/g, "$1")
          .replace(/(亿)万|壹(拾)/g, "$1$2")
          .replace(/^元零?|零分/g, "")
          .replace(/元$/g, "元整");
      } else {
        return false;
      }
    },

    //文件删除
    applyhandleRemove() {
      this.initUpload();
      this.$message.warning("上传的文件已删除！");
    },
    handleUploadFile() {
      this.initUpload();
    },
    initUpload() {
      this.file = null;
      this.showProgress = false;
      this.loadingProgress = 0;
      this.tableData = [];
      this.tableTitle = [];
    }
    // // 读取文件
    // readFile (file) {
    //   const reader = new FileReader()
    //   reader.readAsArrayBuffer(file)
    //   reader.onloadstart = e => {
    //     this.uploadLoading = true
    //     this.tableLoading = true
    //     this.showProgress = true
    //   }
    //   reader.onprogress = e => {
    //     this.progressPercent = Math.round(e.loaded / e.total * 100)
    //   }
    //   reader.onerror = e => {
    //     this.$message({
    //         type:'warning',
    //         message:'文件读取出错'
    //     })
    //   }
    //   reader.onload = e => {
    //     this.$message({
    //       type:'success',
    //       message:'文件读取成功'
    //     })
    //     const data = e.target.result
    //     const { header, results } = excel.read(data, 'array')
    //     const tableTitle = header.map(item => { return { title: item, key: item } })
    //     this.tableData = results
    //     this.tableTitle = tableTitle
    //     this.uploadLoading = false
    //     this.tableLoading = false
    //     this.showRemoveFile = true
    //   }
    // }
  }
};
</script>
<style>
.headImg {
  .upload-demo {
    width: 70%;
    overflow: hidden;
    /deep/.el-upload {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 14px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .table {
    width: calc(100% - 100px);
    margin: 20px 50px;
  }
  .table td {
    width: 50%;
    max-width: 50%;
    border-bottom: 1px dashed #eee;
  }
  .register_head {
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 14px;
    font-weight: 600;
    font-family: "微软雅黑";
    color: DimGray;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-right: 20px;
    //margin-bottom: 30px;
    .login {
      font-size: 12px;
      float: right;
      font-family: "微软雅黑";
      font-weight: 300;
      color: #ccc;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.nomaltr /deep/ td {
  border-bottom: none !important;
}
.nomaltr /deep/ .el-form-item {
  margin-bottom: 0;
}
// .edit_container /deep/ .ql-editor{
//      min-height: 200px !important;
//   }
.edit_container {
  line-height: 24px;
}
.table /deep/ .el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
.nomaltr /deep/ .el-input-number.is-without-controls .el-input__inner {
  padding: 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Hospital/comproject/payment_info.vue